import { Box, Grid, Typography } from '@mui/material';
import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import InputText from '../../../common/Form';
import DatePickerCmp from '../../../common/DatePicker';
import { GroupCheckbox, GroupRadio, GroupSwitch, SingleCheckbox, SingleRadio, SingleSwitch } from '../../../common/RadioAndCheckbox';
import PhotoUpload from '../../../common/PhotoUpload';

const HEADER = {
    "immo" : "Immobilisation",
    "materiel" : "Matériel",
    "vehicule" : "Véhicule",
}

class Usage extends Component {
    state = { 
        equipement_use_start: new Date(),
        equipement_use_end: new Date(),
        equipement_user: "",
        equipement_use_project: "",
        equipement_use_chantier: "",
        
        errors:{
            equipement_use_start: "",
            equipement_use_end: "",
            equipement_user: "",
            equipement_use_project: "",
            equipement_use_chantier: "",
        },
        
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        // TO DO add regex float
        this.setState({
            [name]: value
        })
    }

    handleChangeDate = (date) => {
        this.setState({
            equipement_date: date
        })
    }

    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }
    render() {
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                title={`Nouvelle Utilisation`}
                close={this.props.handleClose}
                appBar
            >
                <Grid container >
                    <Grid item xs={12}>
                        <Box p={1}>
                            <GroupRadio groupName="Type" value={this.props.type} >
                                <SingleRadio value="equipement" label="Materiel" />
                                <SingleRadio value="vehicule" label="Véhicule" />
                            </GroupRadio>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <DatePickerCmp  
                                id="equipement_use_start" 
                                label="Debut" 
                                name="equipement_use_start" 
                                value={this.state.equipement_use_start} 
                                handleChange={this.handleChangeDate} 
                                error={this.state.errors.equipement_use_start}
                                required
                                noPadding
                            />      
                        </Box>
                    </Grid>   
                    <Grid item xs={12} sm={6}>
                        <Box p={1}>
                            <DatePickerCmp  
                                id="equipement_use_end" 
                                label="Fin" 
                                name="equipement_use_end" 
                                value={this.state.equipement_use_end} 
                                handleChange={this.handleChangeDate} 
                                error={this.state.errors.equipement_use_end}
                                required
                                noPadding
                            />      
                        </Box>
                    </Grid>   
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_user"
                            error={this.state.errors.equipement_user}
                            value={this.state.equipement_user}
                            name="equipement_user"
                            label="Utilisateur"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_id"
                            error={this.state.errors.equipement_id}
                            value={this.state.equipement_id}
                            name="equipement_id"
                            label="Select Equipement"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_use_project"
                            error={this.state.errors.equipement_use_project}
                            value={this.state.equipement_use_project}
                            name="equipement_use_project"
                            label="Select Projet"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            onChange={this.handleChange}
                            required
                            id="equipement_use_chantier"
                            error={this.state.errors.equipement_use_chantier}
                            value={this.state.equipement_use_chantier}
                            name="equipement_use_chantier"
                            label="Add Chantier"
                        />
                    </Grid>
                </Grid>      
            </Dialog>
        );
    }
}

export default Usage;